import React, { useState } from 'react';
import { Modal, Button, DatePicker, Space, message, Spin } from 'antd';
import dayjs from 'dayjs';
import { Method_POST_CONTEXTO } from '../../../../service/api';
import { exportLancamentosExcel } from '../LivroRazao/DownloadLivroRazao/util';
import { useDraggableModal } from '../Balancete/utils/modalDraggable';

const { RangePicker } = DatePicker;

const ModalExportarExcel = ({ visible, onClose, initialPeriod, title, zIndex, onFocus }) => {
    const draggableProps = useDraggableModal(zIndex, onFocus, {
        visible,
        modalKey: 'exportExcel',
        initialWidth: 500,
        initialHeight: 250,
        overflow: 'visible'
    });
    const [periodo, setPeriodo] = useState(initialPeriod || [dayjs().startOf('month'), dayjs().endOf('month')]);
    const [loading, setLoading] = useState(false);

    React.useEffect(() => {
        if (visible && initialPeriod) {
            setPeriodo(initialPeriod);
        }
    }, [visible, initialPeriod]);

    const handleExportar = async () => {
        if (!periodo || periodo.length !== 2) {
            message.warning("Selecione um período válido.");
            return;
        }

        setLoading(true);
        try {
            const payload = {
                dataReferencia: periodo[0].startOf('day').toISOString(),
                dataTermino: periodo[1].endOf('day').toISOString(),
                contaContabilDebito: { id: 0 } // Busca todos se id for 0 ou omitido (conforme LivroRazao)
            };

            const res = await Method_POST_CONTEXTO("/empresa/contabilidade/razao/listar", payload);
            const lancamentos = Array.isArray(res) ? res : (res?.data ?? []);

            if (lancamentos.length === 0) {
                message.info("Nenhum lançamento encontrado para o período selecionado.");
            } else {
                exportLancamentosExcel(lancamentos);
                message.success("Lançamentos exportados com sucesso!");
                onClose();
            }
        } catch (error) {
            console.error(error);
            message.error("Erro ao carregar lançamentos para exportação.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title={title || "Exportar Lançamentos para Excel"}
            open={visible}
            onCancel={onClose}
            {...draggableProps}
            styles={{ body: { overflow: 'visible' } }}
            footer={[
                <Button key="cancel" onClick={onClose}>Cancelar</Button>,
                <Button key="export" type="primary" loading={loading} onClick={handleExportar}>
                    Exportar
                </Button>
            ]}
        >
            <Spin spinning={loading} tip="Buscando lançamentos...">
                <Space direction="vertical" style={{ width: '100%', padding: '20px 0' }}>
                    <p>Selecione o período dos lançamentos que deseja exportar:</p>
                    <RangePicker
                        format="DD/MM/YYYY"
                        value={periodo}
                        onChange={(dates) => setPeriodo(dates)}
                        style={{ width: '100%' }}
                        getPopupContainer={trigger => trigger.parentElement}
                    />
                </Space>
            </Spin>
        </Modal>
    );
};

export default ModalExportarExcel;
